import { useState, useEffect } from 'react'
import { ValidMaterialPricingDetailFragment } from '@src/fragments/ProductPricing.generated'

export const useMaterialSelection = (
  materialPricing: ValidMaterialPricingDetailFragment[] | undefined,
  pricingError: any
) => {
  const [selectedMaterial, setSelectedMaterial] =
    useState<ValidMaterialPricingDetailFragment | null>(null)

  const handleSelect = (materialNumber: string) => {
    const selectedMaterial = materialPricing?.find(
      (product) => product.materialNumber === materialNumber
    )
    setSelectedMaterial(selectedMaterial ?? null)
  }

  useEffect(() => {
    if (materialPricing) {
      setSelectedMaterial(materialPricing[0])
    }
  }, [materialPricing, pricingError])

  return {
    selectedMaterial,
    setSelectedMaterial,
    handleSelect,
  }
}
